/* HomeKind v2.1 chrome: announcement rotator, menu drawer and the concept's cart
   (drawer and /cart page), ported from concept/site/index.html (renderCart,
   swapTo, openDrawer, closeDrawers).

   Cart truth is Shopify's AJAX cart. v2.3: every change here is handed to
   HKCartQ (assets/hk-cart-core-v1.js), the single serial queue that owns pack
   pricing and the free Starter Pack; it fires cart:update once per change and
   this file redraws from the cart it carries. hk-pack-upgrade-v5.js and
   hk-kit-v1.js are retired (no longer loaded).

   ES5, guarded: a throw in here must never break adding to cart. */
(function () {
  "use strict";
  if (window.__hkv2Chrome) return; window.__hkv2Chrome = true;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var H = window.HKV2 || {};
  var IMG = H.img || {};
  var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------- announcement rotator (concept: 6s, phones and tablets only) ---------- */
  (function () {
    var list = $("#annList"); if (!list) return;
    var items = $$("li", list), btn = $("#annPause"), ann = list.closest(".ann"), i = 0, userPaused = false, hover = false;
    if (items.length < 2) return;
    var every = Math.max(3, parseInt(ann.getAttribute("data-speed"), 10) || 6) * 1000;
    setInterval(function () {
      if (userPaused || hover || reduce || window.innerWidth >= 1024 || document.hidden) return;
      items[i].classList.remove("on"); i = (i + 1) % items.length; items[i].classList.add("on");
    }, every);
    /* v2.3 (audit P1-1): hover and the button were one flag, and a tap fires a
       compatibility mouseenter before the click, so the first tap un-paused it.
       The button is now the only thing that sets the user's choice, and only a
       real mouse counts as hover. */
    if (btn) btn.addEventListener("click", function () { userPaused = !userPaused; btn.setAttribute("aria-pressed", userPaused ? "true" : "false"); btn.setAttribute("aria-label", userPaused ? "Play announcements" : "Pause announcements"); });
    if (window.PointerEvent) {
      ann.addEventListener("pointerenter", function (e) { if (e.pointerType === "mouse") hover = true; });
      ann.addEventListener("pointerleave", function () { hover = false; });
    }
  })();

  /* ---------- drawers ---------- */
  var scrim = $("#scrim"), cD = $("#cDrawer"), mD = $("#mDrawer"), menuBtn = $("#menuBtn"), cartBtn = $("#cartBtn");
  var lastFocus = null, ptrOpen = false;
  document.addEventListener("pointerdown", function () { ptrOpen = true; }, true);
  document.addEventListener("keydown", function (e) { if (e.key === "Enter" || e.key === " " || e.key === "Tab") ptrOpen = false; }, true);
  var isCartPage = !!$("[data-hk-cartpage]");
  function setInert(on) {
    var wrap = $(".hkv2-drawers");
    Array.prototype.forEach.call(document.body.children, function (el) {
      if (el === wrap || /^(SCRIPT|STYLE|LINK|TEMPLATE)$/.test(el.tagName)) return;
      try { el.inert = on; } catch (e) {}
    });
  }
  function isOpen() { return scrim && !scrim.hidden; }
  function openDrawer(w) {
    if (!cD || !mD) { location.href = "/cart"; return; }
    if (!isOpen()) lastFocus = document.activeElement;
    var d = w === "c" ? cD : mD;
    cD.hidden = true; mD.hidden = true; cD.removeAttribute("open"); mD.removeAttribute("open");
    d.hidden = false; d.setAttribute("open", ""); scrim.hidden = false;
    document.documentElement.classList.add("hk-drawer-open");
    document.body.style.overflow = "hidden"; setInert(true);
    if (ptrOpen) { d.setAttribute("tabindex", "-1"); d.focus({ preventScroll: true }); } else { var c = $("[data-close]", d); if (c) c.focus(); }
    if (menuBtn) menuBtn.setAttribute("aria-expanded", w === "m" ? "true" : "false");
    if (w === "c") refresh();
  }
  function closeDrawers() {
    if (!scrim) return;
    var was = isOpen();
    cD.hidden = true; mD.hidden = true; cD.removeAttribute("open"); mD.removeAttribute("open"); scrim.hidden = true;
    document.documentElement.classList.remove("hk-drawer-open");
    document.body.style.overflow = ""; setInert(false);
    if (menuBtn) menuBtn.setAttribute("aria-expanded", "false");
    if (was && lastFocus && document.body.contains(lastFocus)) { try { lastFocus.focus(); } catch (e) {} }
    lastFocus = null;
  }
  if (menuBtn) menuBtn.addEventListener("click", function () { openDrawer("m"); });
  if (cartBtn) cartBtn.addEventListener("click", function (e) {
    e.preventDefault();
    if (isCartPage) { var h = $("[data-hk-cartpage] h1"); if (h) { h.setAttribute("tabindex", "-1"); h.focus(); h.scrollIntoView({ block: "start" }); } return; }
    openDrawer("c");
  });
  if (scrim) scrim.addEventListener("click", closeDrawers);
  $$("[data-close]").forEach(function (b) { b.addEventListener("click", closeDrawers); });
  document.addEventListener("keydown", function (e) {
    if (!isOpen()) return;
    if (e.key === "Escape") { closeDrawers(); return; }
    if (e.key !== "Tab") return;
    var d = cD.hidden ? mD : cD;
    var f = $$('a[href],button:not([disabled]),input:not([disabled]),textarea,select,iframe,[tabindex]:not([tabindex="-1"])', d).filter(function (x) { return !x.closest("[hidden]") && x.getClientRects().length; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && (document.activeElement === first || !d.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && (document.activeElement === last || !d.contains(document.activeElement))) { e.preventDefault(); first.focus(); }
  });

  /* ---------- cart ---------- */
  var BOTTLE = { "all-in-one-cleaner-concentrate": 1, "two-bottle-pack": 2, "three-bottle-pack": 3 };
  var KIT = "starter-pack";
  var SET = { 1: "", 2: "The Kitchen and Bathroom Set", 3: "The Stock Up Set" };
  var NB = { 1: "1 bottle", 2: "2 bottles", 3: "3 bottles" };
  var SHIP = {
    1: "Express Post, usually 1 to 3 business days.",
    2: "Free standard post (Australia Post regular parcel, usually 2 to 6 business days).",
    3: "Free Express Post, usually 1 to 3 business days."
  };
  var EXPRESS_LINE = "Need it faster? Choose Express Post at checkout, usually 1 to 3 business days.";
  var DISPATCH = "Order by 2pm on a business day and we post it the same day.";
  var KIT_SUB = "Spray bottle, waffle cloth, sponge";
  var SINGLE_C = 3999;
  var MINUS = '<svg viewBox="0 0 14 14" aria-hidden="true"><path d="M2 7h10" stroke="currentColor" stroke-width="1.8"/></svg>';
  var PLUS = '<svg viewBox="0 0 14 14" aria-hidden="true"><path d="M2 7h10M7 2v10" stroke="currentColor" stroke-width="1.8"/></svg>';
  var CODE = [["Lemon", "LEM"], ["Mandarin", "MAN"], ["Peppermint", "PEP"], ["Fragrance", "FF"]];

  function money(c) { var v = c / 100; return "$" + (Math.round(c) % 100 ? v.toFixed(2) : String(Math.round(v))); }
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"']/g, function (m) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[m]; }); }
  function packPrice(n) { return Math.round(9900 * Math.floor(n / 3) + [0, 3999, 7000][n % 3]); }
  function codeOf(name) { for (var i = 0; i < CODE.length; i++) if (String(name).indexOf(CODE[i][0]) === 0) return CODE[i][1]; return null; }
  function scentsOf(title) { return String(title || "").split(" / ").map(function (s) { return s.trim(); }).filter(Boolean); }
  function json(url, body) {
    return fetch(url, { method: body ? "POST" : "GET", credentials: "same-origin", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: body ? JSON.stringify(body) : undefined })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  function announce(cart) {
    var ev; try { ev = new Event("cart:update", { bubbles: true }); } catch (e) { ev = document.createEvent("Event"); ev.initEvent("cart:update", true, false); }
    ev.detail = { resource: cart, sourceId: "hkv2-cart", data: { source: "hkv2-cart", itemCount: cart.item_count } };
    document.dispatchEvent(ev);
  }

  var cart = null, busy = false, giftOn = false, giftMsg = "", giftT = 0;

  /* ---------- v2.4: Change scents, inline in the cart line ----------
     ed: the one open editor { inst: "d" drawer | "p" cart page, vid, keys, k, codes,
     err, saving, loading }. It survives redraws (render() runs on every cart:update)
     and closes itself when its line leaves the cart. Save goes through
     HKCartQ.rescent: one request that swaps the line for the matching variant with
     the same quantity. Stock comes from the product's own .js, read on open. */
  var ed = null, flash = null, prefetched = false;
  var HANDLE_K = { 1: "all-in-one-cleaner-concentrate", 2: "two-bottle-pack", 3: "three-bottle-pack" };
  var SW = { LEM: "#C9C46A", MAN: "#E08A3C", PEP: "#8DB59F", FF: "#D9D2C5" };
  /* per pack size: the scent names in store order, what is in stock at each bottle
     position, and which scent mixes (order ignored) have an in stock variant */
  function stockOf(k) {
    var p = prodCache[HANDLE_K[k]]; if (!p) return null;
    var names = [], seen = {}, pos = [], mix = {};
    ((p.options && p.options[0] && p.options[0].values) || []).forEach(function (n) { var c = codeOf(n); if (c && !seen[c]) { seen[c] = 1; names.push([c, n]); } });
    for (var i = 0; i < k; i++) pos.push({});
    (p.variants || []).forEach(function (v) {
      var cs = vCodes(v); if (cs.length !== k || cs.indexOf(null) > -1) return;
      cs.forEach(function (c) { if (!seen[c]) { seen[c] = 1; names.push([c, c]); } });
      if (!v.available) return;
      cs.forEach(function (c, i) { pos[i][c] = true; });
      mix[cs.slice().sort().join("|")] = true;
    });
    return { names: names, pos: pos, mix: mix };
  }
  function mixOk(S, codes) { return !!(S && S.mix[codes.slice().sort().join("|")]); }
  function edHTML(inst, name) {
    var S = stockOf(ed.k), rows = "";
    if (!S) rows = '<p class="s sced-load">Loading scents</p>';
    else for (var i = 0; i < ed.k; i++) {
      var chips = S.names.map(function (sn) {
        var c = sn[0], on = !!S.pos[i][c], chk = ed.codes[i] === c;
        return '<label class="spill' + (on ? "" : " soon") + '" style="--sw:' + (SW[c] || "#D9D2C5") + '"><input class="sr" type="radio" name="sc-' + inst + "-" + i + '" value="' + esc(c) + '" data-sced-r="' + i + '" data-fid="r' + i + c + '"' + (chk && on ? " checked" : "") + (on ? "" : " disabled") + '><span class="sp-n">' + esc(sn[1]).replace(" + ", "<br>+ ") + "</span>" + (on ? "" : "<small>Back soon</small>") + "</label>";
      }).join("");
      rows += '<fieldset class="srow hk-bottle' + (ed.k === 1 ? " hk-one" : "") + '"><legend class="lbl">' + (ed.k === 1 ? "Choose your scent" : "Bottle " + (i + 1)) + '</legend><div class="spills">' + chips + "</div></fieldset>";
    }
    var bad = S && !mixOk(S, ed.codes), msg = ed.err || (bad ? "That mix is sold out right now. Choose another scent." : "");
    return '<div class="sced" id="sced-' + inst + '" role="group" aria-labelledby="scedH-' + inst + '" data-sced' + (ed.saving ? ' aria-busy="true"' : "") + '>' +
      '<p class="sced-h' + (ed.k === 1 ? " sced-h1" : "") + '" id="scedH-' + inst + '">Change scent' + (ed.k === 1 ? "" : "s") + '<span class="sr">, ' + esc(name) + "</span></p>" + rows +
      '<p class="sced-msg" data-sced-msg' + (msg ? "" : " hidden") + (ed.err ? ' role="alert"' : "") + ">" + esc(msg) + "</p>" +
      '<div class="sced-btns"><button type="button" class="btn btn-buy sced-save" data-sced-save data-fid="save"' + (!S || bad || ed.saving ? " disabled" : "") + ">" + (ed.saving ? "Saving" : "Save scents") + '</button><button type="button" class="btn btn-line sced-cancel" data-sced-cancel data-fid="cancel">Cancel</button></div></div>';
  }
  function bodyOf(inst) { return $('[data-hk-cart-body][data-inst="' + inst + '"]'); }
  function focusIn(inst, sel) { var b = bodyOf(inst), el = b && $(sel, b); if (el) { try { el.focus({ preventScroll: false }); } catch (e) { el.focus(); } } return el; }
  function edOpen(btn, inst) {
    var k = +btn.getAttribute("data-k"), codes = (btn.getAttribute("data-codes") || "").split(",");
    ed = { inst: inst, vid: btn.getAttribute("data-chg"), keys: btn.getAttribute("data-keys"), k: k, codes: codes, err: "", saving: false };
    flash = null;
    if (cart) render(cart);
    var land = function () { var el = focusIn(inst, "[data-sced] input:checked") || focusIn(inst, "[data-sced] input:not([disabled])") || focusIn(inst, "[data-sced-cancel]"); if (el && el.scrollIntoView) { var s = el.closest("[data-sced]"); if (s) s.scrollIntoView({ block: "nearest" }); } };
    if (stockOf(k)) { land(); return; }
    focusIn(inst, "[data-sced-cancel]");
    var mine = ed;
    product(HANDLE_K[k]).then(function () { if (ed !== mine) return; if (cart) render(cart); land(); }, function () { if (ed !== mine) return; ed.err = "Scents did not load. Please try again."; if (cart) render(cart); });
  }
  function edClose(focusVid) {
    var inst = ed ? ed.inst : "d", vid = focusVid || (ed && ed.vid);
    ed = null; if (cart) render(cart);
    if (vid) focusIn(inst, '[data-chg="' + vid + '"]');
  }
  function edCheck() {
    if (!ed) return;
    var b = bodyOf(ed.inst), box = b && $("[data-sced]", b); if (!box) return;
    var S = stockOf(ed.k), bad = S && !mixOk(S, ed.codes), m = $("[data-sced-msg]", box), sv = $("[data-sced-save]", box);
    ed.err = "";
    if (m) { m.textContent = bad ? "That mix is sold out right now. Choose another scent." : ""; m.hidden = !bad; m.removeAttribute("role"); }
    if (sv) sv.disabled = !S || !!bad || ed.saving;
  }
  function edSave() {
    if (!ed || ed.saving || !Q()) return;
    var S = stockOf(ed.k); if (!S || !mixOk(S, ed.codes)) return;
    var mine = ed, codes = ed.codes.slice(), name = "";
    mine.saving = true; mine.err = "";
    var b = bodyOf(mine.inst), box = b && $("[data-sced]", b), sv = box && $("[data-sced-save]", box);
    if (box) box.setAttribute("aria-busy", "true");
    if (sv) { sv.disabled = true; sv.textContent = "Saving"; }
    var ln = b && $('.line[data-vid="' + mine.vid + '"] .t', b); name = ln ? ln.textContent : "";
    Q().rescent(mine.keys, codes).then(function (c) {
      /* the line that now holds these scents: the exact order first, else the same mix */
      var want = codes.join("|"), wantS = codes.slice().sort().join("|"), hit = null, near = null;
      c.items.forEach(function (it) { if (BOTTLE[it.handle] !== mine.k) return; var cs = scentsOf(it.variant_title).map(codeOf); if (cs.join("|") === want && !hit) hit = String(it.variant_id); if (cs.slice().sort().join("|") === wantS && !near) near = String(it.variant_id); });
      var nv = hit || near || mine.vid;
      if (ed === mine) ed = null;
      flash = { vid: nv, inst: mine.inst, until: Date.now() + 4000 };
      render(c);
      focusIn(mine.inst, '[data-chg="' + nv + '"]');
      say("Scents saved. " + name + ": " + codes.map(function (x) { var s = stockOf(mine.k), f = s && s.names.filter(function (n) { return n[0] === x; })[0]; return f ? f[1] : x; }).join(", ") + ". Subtotal " + money(c.total_price) + ".");
      setTimeout(function () { if (flash && flash.vid === nv) flash = null; $$("[data-sced-ok]").forEach(function (x) { x.parentNode && x.parentNode.removeChild(x); }); }, 4000);
    }, function (e) {
      var m = (e && (e.description || e.message)) || "That did not save. Please try again.";
      if (!/not changed|still in your cart/i.test(m)) m += " Your scents have not changed.";
      if (ed === mine) { mine.saving = false; mine.err = m; }
      if (e && e.cart) render(e.cart); else { if (cart) render(cart); refresh(); }
      if (ed === mine) focusIn(mine.inst, "[data-sced-save]:not([disabled])") || focusIn(mine.inst, "[data-sced-cancel]");
      say(m);
    });
  }
  function prefetch(c) {
    if (prefetched) return;
    var hs = {}; c.items.forEach(function (it) { if (BOTTLE[it.handle]) hs[it.handle] = 1; });
    var list = Object.keys(hs); if (!list.length) return;
    prefetched = true;
    setTimeout(function () { list.forEach(function (h) { product(h).catch(function () {}); }); }, 1500);
  }

  function totals(c) {
    var n = 0, save = 0, kitFree = false;
    c.items.forEach(function (it) {
      var b = BOTTLE[it.handle];
      if (b) { n += b * it.quantity; if (b > 1) save += SINGLE_C * b * it.quantity - it.final_line_price; }
      if (it.handle === KIT && it.final_line_price === 0) kitFree = true;
    });
    var phys = !!c.requires_shipping;
    var post = phys && !(n >= 2 || c.total_price >= 7000);
    return { n: n, save: Math.max(0, save), kitFree: kitFree && n > 0, phys: phys, post: post, s: c.total_price };
  }
  function ladderText(T) {
    var n = T.n;
    return n >= 3 ? "Free Express Post unlocked." : (n === 2 ? "Free post unlocked. One more bottle gets free Express Post." : (n === 1 ? (T.post ? "Add a second bottle: two for $70 with free post." : "Your post is already free. A second bottle makes it $35 a bottle.") : "Add a bottle and the Starter Pack is free."));
  }
  function shipLine(T) { return T.n >= 3 ? SHIP[3] : ((T.n === 2 || !T.post) ? SHIP[2] : SHIP[1]); }
  function scentLines(names) {
    var c = {}, o = [];
    names.forEach(function (s) { if (!c[s]) { c[s] = 0; o.push(s); } c[s]++; });
    if (o.length < 2 && c[o[0]] < 2) return esc(names[0] || "");
    return o.map(function (s) { return c[s] + " × " + esc(s); }).join("<br>");
  }
  function rank(it) { return BOTTLE[it.handle] ? 0 : (it.handle === KIT ? 1 : 2); }
  function lineImg(it) {
    var b = BOTTLE[it.handle];
    var src = b ? IMG["pack" + b] : (it.handle === KIT ? IMG.kit : null);
    if (!src && it.image) src = it.image + (it.image.indexOf("?") > -1 ? "&" : "?") + "width=128";
    return src ? '<img src="' + esc(src) + '" alt="" width="64" height="64" loading="lazy">' : '<span class="gcimg" aria-hidden="true"></span>';
  }

  function bodyHTML(c, inst) {
    if (!c.items.length) {
      return '<p class="muted">Your cart is empty. One bottle is $39.99 and makes up to 100 spray bottles.</p><a class="btn btn-buy" href="' + esc((H.packs && H.packs["1"] && H.packs["1"].url) || "/products/all-in-one-cleaner-concentrate") + '">Choose your pack</a>';
    }
    var T = totals(c), n = T.n;
    var rungs = '<ol class="rungs" aria-label="Bottles in your cart: ' + Math.min(n, 3) + ' of 3"><li class="' + (n >= 1 ? "on" : "") + '">1 bottle</li><li class="' + (n >= 2 ? "on" : "") + '">2 bottles<small>Free post</small></li><li class="' + (n >= 3 ? "on" : "") + '">3 bottles<small>Free Express</small></li></ol>';
    var up = "";
    if (n === 1) {
      up = '<div class="upsell"><img src="' + esc(IMG.pack2 || "") + '" alt="" width="56" height="56"><span class="up-lng"><b>Make it the Kitchen and Bathroom Set: two bottles for $70.</b> $35 a bottle, free post, and it still comes with one free Starter Pack.</span><span class="up-sht"><b>Two for $70, free post.</b> $35 a bottle.</span><button type="button" data-swap="2" aria-label="Make it two · $70, swaps your cart to two bottles">Make it two · $70</button></div>';
    } else if (n === 2) {
      var d = money(packPrice(3) - packPrice(2));
      up = '<div class="upsell"><img src="' + esc(IMG.pack3 || "") + '" alt="" width="56" height="56"><span class="up-lng"><b>Make it the Stock Up Set: add a third bottle for ' + d + '.</b> $33 a bottle, with free Express Post.</span><span class="up-sht"><b>Add a third for ' + d + '.</b> Free Express Post.</span><button type="button" data-swap="3" aria-label="Add a third bottle · ' + d + ', swaps your cart to three bottles">Add a third · ' + d + '</button></div>';
    }
    /* Shopify can split one variant over two lines (a discount on one unit); the
       concept shows one line per product, so merge them and change the quantity
       by variant. */
    var byV = {}, merged = [];
    c.items.forEach(function (it) {
      var m = byV[it.variant_id];
      if (!m) { m = byV[it.variant_id] = { handle: it.handle, key: it.key, keys: [], variant_id: it.variant_id, url: it.url, image: it.image, product_title: it.product_title, variant_title: it.variant_title, quantity: 0, final_line_price: 0, original_line_price: 0 }; merged.push(m); }
      m.keys.push(it.key); m.quantity += it.quantity; m.final_line_price += it.final_line_price; m.original_line_price += it.original_line_price;
    });
    var items = merged.map(function (it, i) { return [it, i]; }).sort(function (a, b) { return rank(a[0]) - rank(b[0]) || a[1] - b[1]; }).map(function (x) { return x[0]; });
    var disc = (c.cart_level_discount_applications || []).map(function (d) { return '<div class="adjrow"><span>' + esc(d.title) + '</span><span>' + money(d.total_allocated_amount) + ' off</span></div>'; }).join("");
    var lines = items.map(function (it) {
      var b = BOTTLE[it.handle], kit = it.handle === KIT;
      var free = kit && it.final_line_price === 0 && n > 0;
      var name = b ? (SET[b] ? SET[b] + ", " : "All in One Cleaner Concentrate, ") + NB[b] : (kit ? "Starter Pack" : it.product_title);
      var sub = b ? scentLines(scentsOf(it.variant_title)) : (kit ? KIT_SUB : esc(it.variant_title || ""));
      /* data-h and data-c let the queue finish a fast second tap after the first has already replaced this row */
      var hint = ' data-h="' + esc(it.handle) + '" data-c="' + esc(b ? (codeOf(scentsOf(it.variant_title)[0]) || "") : "") + '"';
      /* bottle rows step in BOTTLES (the queue reshapes them into singles and packs), so
         the number between the buttons is bottles, not pack quantity */
      var shown = b ? b * it.quantity : it.quantity, unit = b ? " bottles by one, " : " quantity, ";
      var qty = '<div class="qty"><button type="button" data-key="' + esc(it.keys.join(",")) + '" data-q="' + (it.quantity - 1) + '" data-dir="-1"' + hint + ' aria-label="Decrease' + unit + esc(name) + '">' + MINUS + '</button><span>' + shown + '</span><button type="button" data-key="' + esc(it.keys.join(",")) + '" data-q="' + (it.quantity + 1) + '" data-dir="1"' + hint + ' aria-label="Increase' + unit + esc(name) + '">' + PLUS + '</button></div>';
      var was = b > 1 ? SINGLE_C * b * it.quantity : 0;
      var price = free ? 'Free<s><span class="sr">On its own </span>' + money(it.original_line_price || 1999) + '</s>'
        : money(it.final_line_price) + (was > it.final_line_price ? '<s><span class="sr">Bought as singles </span>' + money(was) + '</s><small>as singles</small>' : (it.original_line_price > it.final_line_price ? '<s>' + money(it.original_line_price) + '</s>' : ""));
      /* v2.4: Change scents opens an editor inside this line (no trip to the product page) */
      var vid = String(it.variant_id), editing = !!(b && ed && ed.inst === inst && ed.vid === vid);
      var chg = b ? '<button type="button" class="chgsc" data-chg="' + esc(vid) + '" data-keys="' + esc(it.keys.join(",")) + '" data-k="' + b + '" data-codes="' + esc(scentsOf(it.variant_title).map(codeOf).join(",")) + '" aria-expanded="' + (editing ? "true" : "false") + '"' + (editing ? ' aria-controls="sced-' + inst + '"' : "") + '>Change scents<span class="sr">, ' + esc(name) + '</span></button>' : "";
      var ok = b && flash && flash.vid === vid && flash.inst === inst && Date.now() < flash.until ? '<p class="sced-ok" role="status" data-sced-ok><svg viewBox="0 0 20 20" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.2" aria-hidden="true"><path d="m4 10 4 4 8-8"/></svg>Scents saved</p>' : "";
      return '<div class="line' + (editing ? " editing" : "") + '" data-line-key="' + esc(it.key) + '" data-vid="' + esc(vid) + '">' + lineImg(it) + '<div><div class="t">' + esc(name) + '</div><div class="s">' + sub + '</div>' + chg + ok + (free ? '<div class="s hk-freekit">Free with your bottle</div>' : (editing ? "" : qty)) + '</div><div class="p">' + price + '</div>' + (editing ? edHTML(inst, name) : "") + '</div>';
    }).join("");
    var gid = "isGift" + inst, mid = "giftMsg" + inst;
    return (T.phys ? '<div class="ladder"><span>' + ladderText(T) + '</span>' + rungs + '</div>' : "") + up + disc + lines +
      (T.phys ? '<p class="small muted">' + shipLine(T) + " " + (n === 2 ? EXPRESS_LINE + " " : "") + DISPATCH + '</p>' : "") +
      '<div class="giftnote"><label class="hk-giftl"><input type="checkbox" id="' + gid + '" data-gift' + (giftOn ? " checked" : "") + '> This is a gift</label><label for="' + mid + '" data-giftl' + (giftOn ? "" : " hidden") + '>Gift note, up to 200 characters</label><textarea id="' + mid + '" maxlength="200" data-giftmsg' + (giftOn ? "" : " hidden") + '>' + esc(giftMsg) + '</textarea></div>' +
      '<p class="cquote">“Showers and mirrors are SHINING.”<span>HomeKind customer</span></p>';
  }
  function dynHTML(c) {
    var T = totals(c);
    var f1 = (T.save > 0 ? "You save " + money(T.save) + " · " : "") + (!T.phys ? "Delivered by email" : (T.n >= 3 ? "Free Express Post" : (T.post ? (T.kitFree ? "Plus a free Starter Pack" : "Express Post") : "Free post")));
    return '<div class="tot"><span>Subtotal</span><span>' + money(T.s) + '</span></div><p class="cfoot1">' + f1 + '.<span class="g-ph"> Keep the Bottle Guarantee, 30 days.</span></p>' +
      '<form action="/cart" method="post" class="hk-coform" data-hk-co><button type="submit" name="checkout" class="btn btn-buy hk-checkout">' + (T.post ? "Checkout" : "Checkout · " + money(T.s)) + '</button></form>';
  }
  function say(m) { $$("[data-hk-cart-live], #cartLive").forEach(function (l) { l.textContent = ""; setTimeout(function () { l.textContent = m; }, 30); }); }
  function badge(c) {
    var cnt = c.item_count, el = $("#cartCount");
    if (el) { el.hidden = !cnt; el.textContent = cnt; }
    if (cartBtn) cartBtn.setAttribute("aria-label", "Cart, " + cnt + " item" + (cnt === 1 ? "" : "s"));
  }
  function render(c) {
    if (!c || !c.items) return;
    cart = c;
    if (c.attributes) {
      if (!document.activeElement || !document.activeElement.hasAttribute || !document.activeElement.hasAttribute("data-giftmsg")) {
        giftOn = c.attributes["Gift"] === "Yes"; giftMsg = c.attributes["Gift note"] || "";
      }
    }
    badge(c);
    /* v2.4: an open scent editor closes when its line has left the cart (unless it is
       mid save: the save itself decides what happens next) */
    if (ed && !ed.saving && !c.items.some(function (it) { return String(it.variant_id) === ed.vid && BOTTLE[it.handle]; })) ed = null;
    prefetch(c);
    $$("[data-hk-cart-body]").forEach(function (b) {
      var inst = b.getAttribute("data-inst") || "d";
      var active = document.activeElement && b.contains(document.activeElement) ? document.activeElement : null;
      var ak = active && active.getAttribute("data-key"), up = !!(active && /^Increase/.test(active.getAttribute("aria-label") || "")), gift = active && active.hasAttribute("data-giftmsg");
      var fid = active && active.closest && active.closest("[data-sced]") && active.getAttribute("data-fid");
      var chgv = active && active.getAttribute("data-chg");
      if (gift) return;   /* never redraw under someone typing a gift note */
      b.innerHTML = bodyHTML(c, inst);
      if (active) {
        var nb = ak ? $$('[data-key="' + ak + '"]', b).filter(function (x) { return /^Increase/.test(x.getAttribute("aria-label")) === up; })[0] : null;
        if (!nb && fid) nb = $('[data-sced] [data-fid="' + fid + '"]', b) || $("[data-sced-cancel]", b);
        if (!nb && chgv) nb = $('[data-chg="' + chgv + '"]', b);
        if (nb && !nb.disabled) nb.focus(); else if (b.closest("#cDrawer")) { var cl = $("#cDrawer [data-close]"); if (cl) cl.focus(); }
      }
    });
    $$("[data-hk-cart-dyn]").forEach(function (d) { d.innerHTML = c.items.length ? dynHTML(c) : ""; });
    $$("[data-hk-cart-foot]").forEach(function (f) { f.hidden = !c.items.length; });
  }
  function refresh() { return json("/cart.js").then(function (c) { render(c); return c; }).catch(function () {}); }

  function setBusy(on) { busy = on; $$("[data-hk-cart-body], [data-hk-cart-dyn]").forEach(function (b) { if (on) b.setAttribute("aria-busy", "true"); else b.removeAttribute("aria-busy"); }); }
  /* v2.3: every cart write goes through HKCartQ (hk-cart-core-v1.js), one serial
     queue that reads a fresh cart before each change and owns pack pricing and the
     free kit. The drawer no longer writes, converts or announces on its own, so a
     tap can never fan out into a second converter. Taps are queued, not dropped:
     a fast double tap on + is two bottles. The direct write below is only the
     fallback for a page where the core script failed to load. */
  var Q = function () { return window.HKCartQ || null; };
  function change(key, q, name, dir, hint) {
    var done = function (c) { var T = totals(c); var b = BOTTLE[hint && hint.handle]; say(b ? "Your cart: " + T.n + (T.n === 1 ? " bottle" : " bottles") + ". Subtotal " + money(T.s) + ". " + ladderText(T) : (q > 0 ? name + ": quantity " + q + ". Subtotal " + money(T.s) + "." : "Removed " + name + ".")); };
    var fail = function (e) { say((e && (e.description || e.message)) || "That did not update. Please try again."); if (e && e.cart) render(e.cart); else refresh(); };
    if (Q()) { Q().step(key, dir, hint).then(function (c) { render(c); done(c); }, fail); return; }
    if (busy) return; setBusy(true);
    var up = {}; String(key).split(",").forEach(function (k, i) { up[k] = i ? 0 : Math.max(0, q); });
    json("/cart/update.js", { updates: up })
      .then(function (c) { render(c); announce(c); done(c); })
      .catch(fail)
      .then(function () { setBusy(false); });
  }

  /* Make it two / Add a third: swap every bottle line for one pack variant, keeping
     the scents already chosen (concept swapTo: the new bottle is Mandarin unless
     Mandarin is already in, then Lemon Myrtle). Stock is read from the pack
     product, and the canonical variant hk-pack-upgrade-v5 expects is preferred so
     that script has nothing left to swap. */
  var prodCache = {};
  function product(h) { return prodCache[h] ? Promise.resolve(prodCache[h]) : json("/products/" + h + ".js").then(function (p) { prodCache[h] = p; return p; }); }
  function bottleCodes(c) {
    var out = [];
    c.items.forEach(function (it) { if (!BOTTLE[it.handle]) return; for (var q = 0; q < it.quantity; q++) scentsOf(it.variant_title).forEach(function (s) { out.push(codeOf(s) || "LEM"); }); });
    return out;
  }
  function vCodes(v) { return (v.options && v.options.length ? v.options : scentsOf(v.title)).map(codeOf); }
  function swapDone(k, c) {
    render(c);
    say((k === 2 ? "The Kitchen and Bathroom Set" : "The Stock Up Set") + " in your cart. Subtotal " + money(c.total_price) + ".");
    var co = $(".hk-checkout", cD && !cD.hidden ? cD : document); if (co) co.focus();
  }
  function swapTo(k) {
    if (Q()) { Q().swapTo(k).then(function (c) { swapDone(k, c); }, function (e) { say((e && (e.description || e.message)) || "That did not update. Please try again."); if (e && e.cart) render(e.cart); else refresh(); }); return; }
    if (busy || !cart) return; setBusy(true);
    var have = bottleCodes(cart), want = have.slice(0, k);
    while (want.length < k) want.push(want.indexOf("MAN") < 0 ? "MAN" : "LEM");
    var key = want.slice().sort().join("|");
    product(k === 2 ? "two-bottle-pack" : "three-bottle-pack").then(function (p) {
      var av = p.variants.filter(function (v) { return v.available; });
      var canon = window.HK_PACK && window.HK_PACK["PACK" + k] && window.HK_PACK["PACK" + k][key];
      var pick = av.filter(function (v) { return String(v.id) === String(canon); })[0] ||
        av.filter(function (v) { return vCodes(v).slice().sort().join("|") === key; })[0];
      if (!pick) {
        var base = have.slice(0, Math.min(have.length, k));
        pick = av.filter(function (v) { var cs = vCodes(v); return base.every(function (b) { var i = cs.indexOf(b); if (i < 0) return false; cs.splice(i, 1); return true; }); })[0] || av[0];
      }
      if (!pick) throw { description: "That pack is sold out right now." };
      var updates = {};
      cart.items.forEach(function (it) { if (BOTTLE[it.handle]) updates[it.key] = 0; });
      updates[pick.id] = 1;
      return json("/cart/update.js", { updates: updates });
    }).then(function (c) {
      announce(c); swapDone(k, c);
    }).catch(function (e) { say((e && (e.description || e.message)) || "That did not update. Please try again."); refresh(); })
      .then(function () { setBusy(false); });
  }

  function saveGift(now) {
    clearTimeout(giftT);
    var go = function () { var a = { "Gift": giftOn ? "Yes" : "", "Gift note": giftOn ? giftMsg.slice(0, 200) : "" }; return (Q() ? Q().attrs(a) : json("/cart/update.js", { attributes: a })).catch(function () {}); };
    if (now) return go();
    giftT = setTimeout(go, 600);
    return Promise.resolve();
  }
  document.addEventListener("click", function (e) {
    var t = e.target; if (!t || !t.closest) return;
    var host = t.closest("[data-hk-cart-body]");
    if (!host) return;
    var q = t.closest("[data-q]");
    if (q) { e.preventDefault(); var ln = q.closest(".line"), nm = ln ? ($(".t", ln) || {}).textContent : "Item"; var h = q.getAttribute("data-h") || ""; change(q.getAttribute("data-key"), +q.getAttribute("data-q"), nm, +(q.getAttribute("data-dir") || (/^Increase/.test(q.getAttribute("aria-label") || "") ? 1 : -1)), { handle: h, bottle: !!BOTTLE[h], code: q.getAttribute("data-c") || "" }); return; }
    var s = t.closest("[data-swap]");
    if (s) { e.preventDefault(); swapTo(+s.getAttribute("data-swap")); return; }
    var cg = t.closest("[data-chg]");
    if (cg) {
      e.preventDefault();
      var inst = host.getAttribute("data-inst") || "d";
      if (ed && ed.inst === inst && ed.vid === cg.getAttribute("data-chg")) { if (!ed.saving) edClose(); return; }
      if (!Q()) { location.href = "/products/" + (HANDLE_K[+cg.getAttribute("data-k")] || HANDLE_K[1]); return; }   /* no queue: the product page chooser */
      edOpen(cg, inst); return;
    }
    if (t.closest("[data-sced-cancel]")) { e.preventDefault(); if (ed && !ed.saving) edClose(); return; }
    if (t.closest("[data-sced-save]")) { e.preventDefault(); edSave(); return; }
    if (t.closest("a[href]")) closeDrawers();
  });
  /* the scent chips inside the editor: remember the choice so a redraw keeps it */
  document.addEventListener("change", function (e) {
    var t = e.target; if (!t || !t.hasAttribute || !t.hasAttribute("data-sced-r") || !ed) return;
    ed.codes[+t.getAttribute("data-sced-r")] = t.value; edCheck();
  });
  /* Escape inside the editor closes the editor, not the drawer */
  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape" || !ed || !e.target || !e.target.closest || !e.target.closest("[data-sced]")) return;
    e.preventDefault(); e.stopPropagation(); if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    if (!ed.saving) edClose();
  }, true);
  document.addEventListener("change", function (e) {
    var t = e.target; if (!t || !t.hasAttribute || !t.hasAttribute("data-gift")) return;
    giftOn = t.checked;
    $$("[data-hk-cart-body]").forEach(function (b) { $$("[data-giftl],[data-giftmsg]", b).forEach(function (x) { x.hidden = !giftOn; }); $$("[data-gift]", b).forEach(function (x) { x.checked = giftOn; }); });
    saveGift(true);
  });
  document.addEventListener("input", function (e) {
    var t = e.target; if (!t || !t.hasAttribute || !t.hasAttribute("data-giftmsg")) return;
    giftMsg = t.value; saveGift(false);
  });
  document.addEventListener("submit", function (e) {
    var f = e.target; if (!f || !f.hasAttribute || !f.hasAttribute("data-hk-co")) return;
    if (!giftT) return;
    e.preventDefault(); clearTimeout(giftT); giftT = 0;
    saveGift(true).then(function () { f.submit(); });
  }, true);

  /* Other scripts (hk-kit, hk-pack-upgrade, the product page, quick add) announce
     changes with cart:update; redraw from the cart they carry. */
  document.addEventListener("cart:update", function (e) {
    var c = e && e.detail && e.detail.resource;
    if (e && e.detail && e.detail.sourceId === "hkv2-cart") return;
    if (c && c.items && typeof c.total_price === "number") render(c); else refresh();
    var cv = e && e.detail && e.detail.data && e.detail.data.converted;
    if (cv === 2 || cv === 3) say((cv === 2 ? "Pack price applied: two bottles for " : "Pack price applied: three bottles for ") + money(c ? c.total_price : 0) + ".");
  });

  /* ---------- product page sticky buy bar (concept stickyPdp / stickyCheck) ----------
     Replaces hk-cro-v15's bar on the three bottle pages (hidden by CSS). Phones: shows
     once the gallery has scrolled away and Add to cart is out of view; from 901px: once
     Add to cart has scrolled above the top. Add to cart submits the page's own form. */
  (function () {
    var form = $(".hkv2c [data-hkv2-pdp]"); if (!form) return;
    var k = /three-bottle-pack/.test(location.pathname) ? 3 : (/two-bottle-pack/.test(location.pathname) ? 2 : (/all-in-one-cleaner-concentrate/.test(location.pathname) ? 1 : 0));
    if (!k) return;
    var SUB = { 1: "Free Starter Pack · Express Post", 2: "Free post · Free Starter Pack", 3: "Free Express Post · Free Starter Pack" };
    var P = (H.packs && H.packs[k]) || {};
    var wrap = document.createElement("div"); wrap.className = "hkv2c hkv2-stickywrap";
    wrap.innerHTML = '<div class="sticky" id="sticky" aria-hidden="true"><img src="' + esc(IMG["pack" + k] || "") + '" alt="" id="stImg" width="44" height="44" loading="lazy"><span class="t"><b id="stName">' + NB[k] + " · " + money(P.price || [0, 3999, 7000, 9900][k]) + '</b><span id="stSub">' + SUB[k] + '</span></span><button type="button" class="stchg" tabindex="-1">Change</button><button type="button" class="btn btn-buy" tabindex="-1">Add to cart</button></div>';
    document.body.appendChild(wrap);
    var st = $(".sticky", wrap), chg = $(".stchg", st), buy = $(".btn-buy", st), atc = $(".atc", form), gal = $(".hkv2c .gal");
    var wide = window.matchMedia("(min-width:901px)");
    var inView = function (el) { if (!el) return false; var r = el.getBoundingClientRect(); return r.bottom > 0 && r.top < innerHeight; };
    var last = null;
    function check() {
      var on = false;
      if (!isOpen() && atc) on = wide.matches ? atc.getBoundingClientRect().bottom < 0 : (!!gal && gal.getBoundingClientRect().bottom < 0 && !inView(atc));
      if (on === last) return; last = on;
      st.classList.toggle("show", on); st.setAttribute("aria-hidden", on ? "false" : "true");
      buy.tabIndex = on ? 0 : -1; chg.tabIndex = on ? 0 : -1;
      document.documentElement.style.setProperty("--hk-bar-h", on ? (st.offsetHeight || 68) + "px" : "0px");
      document.documentElement.style.scrollPaddingBottom = on ? "96px" : "";
    }
    buy.addEventListener("click", function () { if (atc && !atc.disabled) { if (form.requestSubmit) form.requestSubmit(atc); else atc.click(); } else if (atc) atc.scrollIntoView({ block: "center" }); });
    chg.addEventListener("click", function () { var p = $(".hkv2c #packs"); if (p) { p.scrollIntoView({ behavior: reduce ? "auto" : "smooth", block: "center" }); var c = $('[aria-current], input:checked', p); if (c) c.focus({ preventScroll: true }); } });
    window.addEventListener("scroll", check, { passive: true }); window.addEventListener("resize", check, { passive: true });
    document.addEventListener("click", function () { setTimeout(check, 80); }, true);
    check();
  })();

  /* ---------- pack summary strip (concept #fromAd) ----------
     The concept shows "N bottles · $X. Free Starter Pack included. Change" whenever the
     product page is opened for a chosen pack (its links carry ?pack=N: the pack cards,
     the footer's set links, ad links). Phones: under the gallery dots; from 901px: under
     the product title. Pack card links get ?pack=N here so the same journeys show it. */
  (function () {
    var rx = /^\/products\/(all-in-one-cleaner-concentrate|two-bottle-pack|three-bottle-pack)\/?$/;
    var kOf = function (p) { return /three/.test(p) ? 3 : (/two/.test(p) ? 2 : 1); };
    $$(".hkv2c a.card[href], .hkv2c .card a[href], .hkv2c a.h3link[href], .hkv2c footer.site a[href]").forEach(function (a) {
      try { var u = new URL(a.getAttribute("href"), location.origin); if (u.origin !== location.origin || !rx.test(u.pathname) || u.searchParams.get("pack")) return; if (a.closest("footer.site") && !/two|three/.test(u.pathname)) return; u.searchParams.set("pack", kOf(u.pathname)); a.setAttribute("href", u.pathname + u.search); } catch (e) {}
    });
    var form = $(".hkv2c [data-hkv2-pdp]"); if (!form || !rx.test(location.pathname)) return;
    var k = kOf(location.pathname), qp = null;
    try { qp = new URLSearchParams(location.search).get("pack"); } catch (e) {}
    if (!/^[123]$/.test(qp || "")) return;
    /* v2.3 (audit P1-2): an ad or email link like /products/all-in-one-cleaner-concentrate?pack=3
       used to show and add one bottle. Send it to the product that matches the pack. */
    if (+qp !== k) { location.replace({ 1: "/products/all-in-one-cleaner-concentrate", 2: "/products/two-bottle-pack", 3: "/products/three-bottle-pack" }[qp] + location.search + location.hash); return; }
    /* keep the strip while she moves between packs */
    $$(".hkv2c #packs a.pack[href]").forEach(function (a) { try { var u = new URL(a.getAttribute("href"), location.origin); u.searchParams.set("pack", kOf(u.pathname)); a.setAttribute("href", u.pathname + u.search); } catch (e) {} });
    var P = (H.packs && H.packs[k]) || {};
    var fa = document.createElement("p"); fa.className = "from-ad"; fa.id = "fromAd";
    fa.innerHTML = "<b>" + NB[k] + " · " + money(P.price || [0, 3999, 7000, 9900][k]) + (k !== 1 ? " · " + (k === 3 ? "Free Express Post" : "Free post") : "") + '.</b> Free Starter Pack included. <a href="#packs" data-scrollto="packs">Change</a>';
    var dots = $(".hkv2c #galDots"), h1 = $(".hkv2c .b-title h1") || $(".hkv2c .buy h1");
    var wideQ = window.matchMedia("(min-width:901px)");
    var place = function () { var t = wideQ.matches ? h1 : dots; if (t && fa.previousElementSibling !== t) t.insertAdjacentElement("afterend", fa); };
    place(); if (wideQ.addEventListener) wideQ.addEventListener("change", place);
  })();

  window.HKCart = { open: function () { openDrawer("c"); }, close: closeDrawers, refresh: refresh, render: render, openMenu: function () { openDrawer("m"); } };
  if ($("[data-hk-cart-body]")) refresh();
})();
